/**
 * 应用类型
 */
enum AppType {
  Akulaku = "akulaku",
  Silvrrplus = "silvrrplus",
  Silvrr = "silvrr",
}

export enum AppValueType {
  Akulaku = 1,
  Silvrrplus,
  Silvrr,
  M,
}

export default AppType;
